const errors = {
  101: function () {
    return 'ユーザー名かパスワードが間違っています。'
  },

  200: function () {
    return 'ユーザー名を入力してください。'
  },

  201: function () {
    return 'パスワードは必須です。'
  },

  1000: function () {
    return 'メッセージは必須です。'
  },

  1001: function () {
    return 'ユーザー名は必須です。'
  },

  1002: function () {
    return 'パスワードは必須です。'
  },

  1003: function () {
    return '開始時間と終了時間が同じか、または超えています。'
  }
}

const getters = {
  status: () => (error) => {
    if (errors[error.code] === null) {
      return 'エラーが発生しました。管理者に問い合わせてください。'
    }

    console.log(error)
    if (!error.code) {
      console.log(error)
    }
    return errors[error.code]()
  }
}

export default {
  namespaced: true,
  getters
}
